<template>
  <div style="margin-bottom: 5%">
    <el-upload
      ref="uploadFile"
      class="upload-demo"
      :drag="true"
      action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
      :limit="1"
      :on-exceed="handleExceed"
      list-type="picture-card"
      :auto-upload="false"
      :on-success="handleUploadOnSuccess"
      :on-change="handleChange"
      :on-remove="handleRemove"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        Suelta tu archivo aquí o <em>haz clic para cargar</em>
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileList: [],
      filesUpload: 0,
      refFather: null
    };
  },
  methods: {
    handleUploadOnSuccess(response) {
      this.fileList = response[0];
      this.refFather.model.Evidence = this.fileList.Url;
      this.refFather.CreateRequestVacation();
      //   console.log("hello");
    },
    handleChange() {
      this.filesUpload = 1;
    },
    handleRemove() {
      this.filesUpload = 0;
    },
    submitUpload(thiss) {
      this.refFather = thiss;
      this.$refs.uploadFile.submit();
    },
    handleExceed(files) {
      this.$message.warning(
        `El límite es 1, haz seleccionado ${
          files.length
        } archivos esta vez, añade hasta ${files.length + 0}`
      );
    }
  }
};
</script>
